import {
  Box,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Flex,
  Link,
  Text,
} from "@chakra-ui/react";
import { QuestionIcon } from "@chakra-ui/icons";
import { getTwitterShareLink } from "../utils/stringModifier";

interface Props {
  message: string;
  url: string;
}
export default function ToolHelp({ message, url }: Props) {
  return (
    <Box position="fixed" right="0" bottom="0">
      <Popover>
        <PopoverTrigger>
          <IconButton
            variant="ghost"
            aria-label="contact info"
            icon={<QuestionIcon w={6} h={6} color="gray.600" />}
          />
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody>
            <Flex gap={1}>
              <Text>Feedback: </Text>
              <Link
                href="https://twitter.com/tanyoknits"
                textDecoration="underline"
              >
                @tanyoknits
              </Link>
            </Flex>
            <Link
              className="twitter-share-button"
              textDecoration="underline"
              href={getTwitterShareLink(message, url)}
            >
              Share on Twitter
            </Link>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
}
